import { BaseRouteService } from "./BaseRouteService";

export interface StopwatchStatusResponse {
    startTime: number | null; // null = nog niet gestart
    isPaused: boolean;
    isStopped: boolean;
}

export interface StartGameResponse {
    message: string;
    startTime: number;
}

export class StopwatchService extends BaseRouteService {
    public async startGame(): Promise<StartGameResponse> {
        return this.postJsonApi<StartGameResponse>("game/stopwatch/start");
    }

    public async getStartTime(): Promise<StartGameResponse> {
        return this.getJsonApi<StartGameResponse>("game/stopwatch/time");
    }

    public async pauseGame(): Promise<{ message: string }> {
        return this.postJsonApi<{ message: string }>("game/stopwatch/pause");
    }

    public async resumeGame(): Promise<{ message: string }> {
        return this.postJsonApi<{ message: string }>("game/stopwatch/resume");
    }

    public async getStatus(): Promise<StopwatchStatusResponse> {
        return this.getJsonApi<StopwatchStatusResponse>("game/stopwatch/status");
    }

    public async quitGame(): Promise<{ message: string; endTime: number; totalTime: number }> {
        return this.postJsonApi("game/stopwatch/quit");
    }

    public async finishGame(): Promise<{ message: string; totalTime: number }> {
        return this.postJsonApi<{ message: string; totalTime: number }>("game/stopwatch/finish");
    }

    public async quitAndReset(): Promise<{ page: string }> {
        return this.postJsonApi<{ page: string }>("game/quit");
    }
}
